import { createSelector } from '@reduxjs/toolkit';

import type { IState } from '@/Module/Store/Model';
import type { ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel';
import type { ITeacherInfo } from '@/Module/Teacher/Model/DataModel/ITeacherListByCategory';
import { teacherCategoryAdapter } from '@/Module/Teacher/Store/Adapter';
import { categoryTeacherListSelectByCategoryId } from '@/Module/Teacher/Store/Selector/index';

export const categoryTeacherListTeacherSelector = createSelector(
  [
    (state: IState, categoryTeacherId: ITeacherCategoryListCategory['id']) =>
      categoryTeacherListSelectByCategoryId(state, categoryTeacherId),
    (_state: IState, _categoryTeacherId: ITeacherCategoryListCategory['id'], teacherId: ITeacherInfo['id']) => teacherId,
  ],
  (categoryTeacher, teacherId) => {
    if (!categoryTeacher?.teacherList) return null;

    return teacherCategoryAdapter.getSelectors().selectById(categoryTeacher.teacherList, teacherId);
  },
);
